'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LINK_TYPE = exports.LINK_TYPE = 'LINK';
var LINK_DISPLAY_NAME = exports.LINK_DISPLAY_NAME = 'Link';


//////////////////
// WEBPACK FOOTER
// ./src/common/links/linkConstants.js
// module id = 174
// module chunks = 0